<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'pedidos_almacen'"><CrudPedidos /></div>
    <div v-if="view === 'reporte_almacen'"><ReporteAlmacen /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import CrudPedidos from "@/components/TableroProduccion/SeguimientoPedidos/CrudPedidosSeguimiento.vue";
import ReporteAlmacen from "@/components/Inyeccion/ReporteAlmacen.vue";

const view = ref("pedidos_almacen");
</script>
